import React from 'react';

const CashFlow = ({ cashFlow = {}, loading = false }) => {
  const {
    potentialRevenue = 0,
    invoicedRevenue = 0,
    paidRevenue = 0
  } = cashFlow;

  const CashFlowCard = ({ title, subtitle, amount, color = 'blue' }) => {
    const getColorClasses = (color) => {
      switch (color) {
        case 'yellow':
          return {
            bg: 'bg-yellow-50',
            border: 'border-yellow-200',
            text: 'text-yellow-900',
            accent: 'text-yellow-600'
          };
        case 'green':
          return {
            bg: 'bg-green-50',
            border: 'border-green-200',
            text: 'text-green-900',
            accent: 'text-green-600'
          };
        case 'blue':
        default:
          return {
            bg: 'bg-blue-50',
            border: 'border-blue-200',
            text: 'text-blue-900',
            accent: 'text-blue-600'
          };
      }
    };

    const colors = getColorClasses(color);

    return (
      <div className={`${colors.bg} ${colors.border} border rounded-lg p-4`}>
        <p className={`text-sm font-medium ${colors.accent} mb-1`}>{title}</p>
        <p className={`text-2xl font-bold ${colors.text}`}>
          ${amount.toLocaleString('en-US', { maximumFractionDigits: 0 })}
        </p>
        {subtitle && (
          <p className={`text-xs ${colors.text} opacity-75 mt-1`}>{subtitle}</p>
        )}
      </div>
    );
  };

  if (loading) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        {[1, 2, 3].map((i) => (
          <div
            key={i}
            className="bg-gray-50 border border-gray-200 rounded-lg p-4 animate-pulse"
          >
            <div className="h-4 bg-gray-200 rounded w-2/3 mb-2"></div>
            <div className="h-8 bg-gray-200 rounded w-full"></div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
      <CashFlowCard
        title="Potential Revenue"
        subtitle="(Quotes Sent)"
        amount={potentialRevenue}
        color="yellow"
      />
      <CashFlowCard
        title="Sold/Signed"
        subtitle="(Invoiced)"
        amount={invoicedRevenue}
        color="blue"
      />
      <CashFlowCard
        title="Paid"
        subtitle="(Payments Received)"
        amount={paidRevenue}
        color="green"
      />
    </div>
  );
};

export default CashFlow;
